import * as React from "react";
import { emailNotificationStatusesThunk } from "../../../../../../../store/redux/slice/AppData/emailNotificationStatuses";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { SEARCH_FILTERS_GROUP } from "../../../../../../../config/search/filters/groupsConfig";
import { RootState, store } from "../../../../../../../store/redux/store";
import { NomenclatureAutocompleteFilter } from "@duosoftbg/nacid-components";

const EmailNotificationStatusFilter = () => {
  const group = SEARCH_FILTERS_GROUP.EMAIL_NOTIFICATIONS;

  const thunkState = useAppSelector((state) => {
    return state.AppData.emailNotificationStatuses;
  });

  const getPreviousStateOptionFn = () => {
    const state = store.getState() as RootState;
    const statusId = state.SearchData.portalSearchTable[group].filtersData.status;
    const options = state.AppData.emailNotificationStatuses.data;
    return options.find((element) => element.id === statusId);
  };

  return (
    <NomenclatureAutocompleteFilter
      filter={"status"}
      thunkFn={emailNotificationStatusesThunk}
      thunkState={thunkState}
      getPreviousStateOptionFn={getPreviousStateOptionFn}
    />
  );
};

export default EmailNotificationStatusFilter;
